module.exports = __webpack_public_path__ + "img/qx1.79672219.png";